import { render, staticRenderFns } from "./TypesList.vue?vue&type=template&id=67c165d4"
import script from "./TypesList.vue?vue&type=script&lang=js"
export * from "./TypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports